import {Box} from '@chakra-ui/react';
import {Category, ScrollingMenu, ScrollingMenuCard} from 'components/shared';
import {IFilterType} from 'hooks';
import React, {FC} from 'react';
import {ICategoryByProviderResponse, ProviderTypeEnum} from 'types';

interface Props {
  categories: ICategoryByProviderResponse[];
  providerType?: ProviderTypeEnum;
  onFilterChange?: (filters: IFilterType) => void;
  isFromMainPage?: boolean;
}

export const CategoryList: FC<Props> = React.memo(({onFilterChange, categories, providerType, isFromMainPage}) => {
  const onHandleChangeFilters = (filters: IFilterType) => {
    onFilterChange &&
      onFilterChange({
        categorySlug: filters.categorySlug,
        filters: filters.filters,
        promo_type: filters.promo_type,
        products: isFromMainPage,
        ordering: 'default',
      });
  };

  return (
    <Box px={[0, '10px']}>
      <ScrollingMenu>
        {categories.map((item, index) => (
          <ScrollingMenuCard itemId={`element-${index}`} key={item.id}>
            <Box px={['0px', '12px']}>
              <Category
                {...item}
                key={index}
                providerType={providerType}
                isFromMainPage={isFromMainPage}
                onChange={(categorySlug) => onHandleChangeFilters({categorySlug})}
              />
            </Box>
          </ScrollingMenuCard>
        ))}
      </ScrollingMenu>
    </Box>
  );
});
